'use client'

import { AppTitle } from '@/components/atoms/AppTitle/AppTitle'
import { PrivacyPolicyModal } from '@/features/Auth/ui/PrivacyPolicyModal/PrivacyPolicyModal'
import { TermsModal } from '@/features/Auth/ui/TermsModal/TermsModal'
import { useModal } from '@/features/Modal/Modal.hooks'
import { setLocalStorage } from '@/shared/helpers/localStorage'
import { trackUserAction } from '@/shared/helpers/sentry'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import { Button, Checkbox, Flex } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { AuthStep } from '@/features/Auth/auth.types'
import React, { useCallback, useState } from 'react'
import styles from './AuthTerms.module.scss'
import '@splidejs/react-splide/css'

const splideOptions = {
  arrows: false,
  pagination: true,
  waitForTransition: true,
  perPage: 1,
  perMove: 1,
  speed: 500,
  direction: 'ltr',
  gap: 8,
  padding: 16,
  autoplay: true,
}

export function AuthTerms({ setStep }: { setStep?: (step: AuthStep) => void }) {
  const { createModal } = useModal()
  const [isTermsAccepted, setTermsAccepted] = useState(false)

  const handleTerms = useCallback((e: CheckboxChangeEvent) => {
    setTermsAccepted(e.target.checked)
  }, [])

  const handleConnect = useCallback(() => {
    if (isTermsAccepted) {
      trackUserAction('User accepted terms and continued to wallet selection')
      setLocalStorage('godefi:auth:rules', 'true')
      setStep(AuthStep.WALLETS)
    }
  }, [isTermsAccepted, setStep])

  const handleTermsModal = useCallback(() => {
    createModal(<TermsModal />)
  }, [createModal])

  const handlePrivacyModal = useCallback(() => {
    createModal(<PrivacyPolicyModal />)
  }, [createModal])

  return (
    <div className="">
      <Flex gap={50} vertical justify="center" align="center" className="mobileContainer">
        <Flex vertical gap={56} flex={1} justify="center" className="w-full">
          <img src="/moon-mobile.png" className={styles.moon} alt="GoDefi" />
          <div className="splideMainSlider">
            <Splide aria-label="Slider" options={splideOptions}>
              <SplideSlide><div><AppTitle text={<>DeFi wallet is now<br />the key to decentralized <br/>banking</>} centered /></div></SplideSlide>
              <SplideSlide><div><AppTitle text={<>Spend on-chain,<br/> use tokens as collateral,<br/> and earn income</>} centered /></div></SplideSlide>
              <SplideSlide><div><AppTitle text={<>Connect your wallet <br/>and enjoy all the benefits <br/> of Defi banking</>} centered /></div></SplideSlide>
            </Splide>
          </div>
        </Flex>
        <Flex vertical gap={20} className={styles.connect}>
          <Checkbox onChange={handleTerms}>
            I agree to the
            {' '}
            <a href="#" onClick={handlePrivacyModal}>Privacy Policy</a>
            {' '}
            and
            {' '}
            <a href="#" onClick={handleTermsModal}>Terms and Conditions</a>
          </Checkbox>
          <Button onClick={handleConnect} disabled={!isTermsAccepted} type="primary" size="large" block>Connect Wallet</Button>
        </Flex>
      </Flex>
    </div>
  )
}
